<div
  class="aos-report-group-modal"
  [class.aos-report-group-modal_default]="isDefaultView()"
>
  @if (isDefaultView()) {
    <form
      class="aos-report-group-modal__form"
      [formGroup]="reportGroupsForm"
      (ngSubmit)="onSubmit()"
    >
      <span class="aos-report-group-modal__section-label">{{ generalLabel | translate }}</span>
      <div>
        <label
          for="groupName"
          class="aos-report-group-modal__label-common"
        >
          {{ reportGroupNameLabel | translate }}
        </label>
        <input
          [class.is-invalid]="reportGroupsForm.get('groupName')?.errors?.['conflict']"
          type="text"
          id="groupName"
          formControlName="groupName"
          [placeholder]="enterNamePlaceholder | translate"
          class="aos-report-group-modal__input-common aos-report-group-modal__name-input"
        />
      </div>
      @if (reportGroupsForm.get('groupName')?.errors?.['conflict']) {
        <div class="error-message">{{ reportGroupNameExistsError | translate }}</div>
      }
      <div>
        <label
          for="groupDescription"
          class="aos-report-group-modal__label-common"
          >{{ descriptionOptionalLabel | translate }}
        </label>
        <aos-textarea
          id="groupDescription"
          [maxLength]="descriptionMaxLength"
          formControlName="groupDescription"
        />
      </div>
      <div>
        <label
          for="groupDescription"
          class="aos-report-group-modal__label-common aos-report-group-modal__label-status"
          >{{ statusLabel | translate }}
        </label>
        <div class="aos-report-group-modal__switch">
          <ui-switch formControlName="isActive" />
          <span class="aos-report-group-modal__switch-label"> {{ isActive | translate }}</span>
        </div>
      </div>
      <span class="aos-horizontal-divider"></span>

      <div>
        <span class="aos-report-group-modal__section-label">{{ applicableLabel | translate }}</span>
        <span class="aos-report-group-modal__section-description">{{ applicableSub1Label | translate }}</span>
        <span class="aos-report-group-modal__section-description">{{ applicableSub2Label | translate }}</span>
      </div>

      <div class="aos-report-group-modal__applicable">
        <div class="aos-report-group-modal__applicable-checkboxes">
          <span class="aos-report-group-modal__applicable-item">
            <span>
              <kendo-checkbox
                (change)="markForCheck()"
                formControlName="consumptionAnalytics"
              ></kendo-checkbox>
            </span>
            <span>{{ consumptionAnalyticsLabel | translate }}</span>
          </span>
          <span class="aos-report-group-modal__applicable-item">
            <span>
              <kendo-checkbox
                (change)="markForCheck()"
                formControlName="amiHealthDashboard"
              ></kendo-checkbox>
            </span>
            <span>{{ amiHealthDashboardLabel | translate }}</span>
          </span>
          <span class="aos-report-group-modal__applicable-item">
            <span>
              <kendo-checkbox
                (change)="markForCheck()"
                formControlName="networkMonitoring"
              ></kendo-checkbox>
            </span>
            <span>{{ networkMonitoringLabel | translate }}</span>
          </span>
        </div>
      </div>

      <aos-report-groups-filter-criteria
        [form]="$any(reportGroupsForm.controls['filterCriteria'])"
        [setUdfToFiltersDropDownItem]="udf"
      ></aos-report-groups-filter-criteria>
    </form>

    <!-- Footer -->
    <div class="aos-report-group-modal__footer-container">
      <div>
        @let hasReportGroupDeleteRight = hasReportGroupDeleteRight$ | async;
        @if (editReportGroupsFormData && hasReportGroupDeleteRight && canDelete()) {
          <ui-button
            class="delete-button"
            [disabled]="isApiCallInProgress"
            [themeColor]="'secondary'"
            (clicked)="deleteReportGroup()"
            >{{ deleteLabel | translate }}
          </ui-button>
        }
      </div>
      <div class="aos-report-group-modal__footer-container-end">
        <ui-button
          [themeColor]="'secondary'"
          (click)="cancelButtonClick.emit()"
          >{{ cancelLabel | translate }}
        </ui-button>
        <ui-button
          [disabled]="isSubmitDisabled"
          [themeColor]="'primary'"
          (clicked)="onSubmit()"
          >{{ submitButtonText | translate }}
        </ui-button>
      </div>
    </div>
  } @else if (isMapView()) {
    <section class="aos-report-group-modal__map-container">
      <ui-map
        class="aos-report-group-modal__map"
        [authToken]="(authToken$ | async)!"
        [tileEndpoint]="tileEndpoint"
        [chartSegmentsColors]="chartSegmentsColors"
        [itemsCountFieldName]="itemsCountFieldName"
        [itemsBadgesFieldName]="'aggregatedDeviceTypes'"
        [createBadgesFn]="createBadgesFn"
        [isPolygonEnabled]="true"
        [boundingBox]="defaultCoordinates"
        (areaSelected)="onAreaSelected($event)"
      ></ui-map>
    </section>

    <div class="aos-report-group-modal__footer-container aos-report-group-modal__footer-container-end">
      <ui-button
        themeColor="secondary"
        (click)="cancelLassoEdit()"
        >{{ backLabel | translate }}
      </ui-button>
      <ui-button
        themeColor="primary"
        (click)="applyLassoEdit()"
        >{{ applyLabel | translate }}
      </ui-button>
    </div>
  }
</div>
